import { DataTable, Heading, Loader } from "@/components";
import { Badge, Input } from "@/components/ui";
import { cn } from "@/lib/utils";
import { Info, Search } from "lucide-react";
import useBulkUploadHistory from "./useBulkUploadHistory";

const statusChips = [
  { value: "ALL", label: "All" },
  { value: "COMMITTED", label: "Imported", indicator: "bg-green-600" },
  { value: "VALIDATED", label: "Validated only", indicator: "bg-gray-500" },
];

const BulkUploadHistory = () => {
  const {
    communityData, breadcrumbData, columns, historyData, isLoading, globalFilter, setGlobalFilter,
    statusFilter, onStatusFilterChange, pageNumber, pageSize, setPageNumber, setPageSize,
    sorting, setSorting, onRowClick,
  } = useBulkUploadHistory();

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <Heading title="Bulk Upload History" breadcrumbData={breadcrumbData} />
        <Input
          type="text"
          placeholder="Search file or user"
          value={globalFilter ?? ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          className="w-full sm:w-72 bg-white h-[40px]"
          startIcon={<Search className="w-4 h-4" />}
        />
      </div>

      <div className="flex flex-row items-center gap-3 text-[14px] bg-blue-50 border-blue-100 border rounded-md p-4 mb-5">
        <Info className="h-5 w-5 shrink-0" />
        <span>
          Every owner file uploaded to {communityData?.name ?? "this community"}. <b>Validated only</b> means the
          file was checked but never imported. Open an upload to see what happened to each row.
        </span>
      </div>

      <div className="flex flex-row flex-wrap gap-3 mb-4">
        {statusChips.map((chip) => (
          <Badge
            key={chip.value}
            className={cn(
              "rounded-full min-w-[70px] h-[30px] cursor-pointer border-1 border-gray-200",
              chip.value == statusFilter ? "" : "bg-white text-black",
              "transition-all duration-150 active:scale-95 ease-out"
            )}
            onClick={() => onStatusFilterChange(chip.value)}
          >
            {chip.indicator ? <div className={cn("rounded-full h-2 w-2", chip.indicator)} /> : <></>} {chip.label}
          </Badge>
        ))}
      </div>

      {isLoading ? <Loader /> :
        <DataTable
          data={historyData?.data || []}
          columns={columns}
          pageNumber={pageNumber}
          pageSize={pageSize}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          totalPages={Math.ceil((historyData?.total ?? 0) / pageSize)}
          totalRecords={historyData?.total}
          serverSidePagination={true}
          sorting={sorting}
          onSortingChange={setSorting}
          onRowClick={onRowClick}
        />
      }
    </div>
  );
};

export default BulkUploadHistory;
